import React, {useCallback, useEffect, useState} from 'react';
import {useStyles} from '../../../../../../../../shared/hooks/styles';
import {UserCardMobile} from '../../userCard/mobile/';
import {Platform, SafeAreaView, TouchableOpacity, View} from 'react-native';
import {Text} from '../../../../../../../../shared/components/text';
import {Button} from '../../../../../../../../shared/components/button';
import {useIsDesktop} from '../../../../../../../../shared/hooks/useIsDesktop';
import {useDispatch, useSelector} from 'react-redux';
import {esiaRegistrationInfoSelector, esiaUserHasNoCardsSelector} from '../../../../../../../../redux/selectors/login';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../../../../../shared/routing';
import Screen from '../../../../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../../../../shared/components/scrollView';
import {useRegCardState} from '../../../../../esiaRegCardState/useRegCardState';
import {images} from '../../../../../../../../assets/icons';
import {useTheme} from '../../../../../../../../shared/theme';
import {holderProfileSelector} from '../../../../../../../../redux/selectors/profile';
import {useIsSmallScreenDevice} from '../../../../../../../../shared/hooks/useIsSmallScreenDevice';
import {setRuntimeLoginStepState} from '../../../../../../../../redux/actions/runtime/loginStep';
import {LoginState} from '../../../../../../../../shared/models/login/loginStep';
import {useCustomBackhandler} from '../../../../../../../../shared/hooks/useCustomBackhandler';

export const UserCardListMobile = () => {
  const isDesktopSize = useIsDesktop();
  const isSmallScreen = useIsSmallScreenDevice();
  const profile = useSelector(holderProfileSelector());
  const styles = useStyles(({theme, isDesktop}) => ({
    modalTitle: {
      paddingTop: 20,
      ...theme.fonts.h3,
    },
    modalWrap: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingHorizontal: 0,
      overflow: 'hidden',
      width: 878,
      margin: Platform.OS === 'ios' ? 1 : 0,
    },
    contentStyle: {
      paddingTop: 0,
    },
    backButton: {
      marginTop: 16,
    },
    kidsSectionTitle: {
      marginTop: 20,
      marginLeft: 20,
      ...theme.fonts.h3Light,
    },
    btn: {
      marginBottom: isDesktop || profile ? 40 : 80,
      width: isDesktop ? '80%' : '100%',
      textAlign: 'center',
      padding: 6,
      alignSelf: 'center',
      marginTop: 25,
    },
    header: {
      ...theme.topBar.header,
      elevation: 6,
      minHeight: 54,
      paddingRight: 10,
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    headerBackBtn: {
      width: 48,
      height: 48,
      alignItems: 'center',
      justifyContent: 'center',
    },
    headerTitle: {
      paddingRight: 24,
    },
  }));

  const theme = useTheme();
  const navigation = useNavigation();
  const esiaRegInfo = useSelector(esiaRegistrationInfoSelector);
  const {addData, kids, parent} = useRegCardState();
  const [isButtonDisabled, setIsButtonDisabled] = useState(parent?.checked);
  const dispatch = useDispatch();
  useEffect(() => {
    setIsButtonDisabled(parent?.checked);
  }, [parent]);

  useEffect(() => {
    if (esiaRegInfo) {
      addData(esiaRegInfo);
    }
  }, []);

  useEffect(() => {
    if (kids.length === 0 && profile) {
      navigation.navigate(Screens.EsiaLoginAfterLogged);
    }
  }, [kids, profile]);

  kids.sort((a, b) => {
    return a.errors.length - b.errors.length;
  });
  const haveKids = kids.length > 0 ? true : false;
  useCustomBackhandler();
  const goBack = useCallback(() => {
    if (navigation.canGoBack()) {
      dispatch(setRuntimeLoginStepState(LoginState.esiaRegCardUnconfirmed));
      navigation.goBack();
    } else {
      navigation.navigate(Screens.Login);
    }
  }, [navigation]);

  return (
    <Screen>
      <SafeAreaView>
        {!profile ? (
          <View testID='header-container' style={styles.header}>
            <TouchableOpacity onPress={goBack} style={styles.headerBackBtn} testID='header-content'>
              <images.Left height={24} width={24} color={theme.color.primaryColor} />
            </TouchableOpacity>
            <Text type={isSmallScreen ? 'action' : 'h6'} style={styles.headerTitle}>
              Оформление нефинансовой ЕСК
            </Text>
          </View>
        ) : null}
        <View style={{height: `100%`}}>
          <CustomScrollView contentInsetAdjustmentBehavior='automatic' withRefresh={false}>
            <View style={{display: 'flex', flexDirection: 'column', margin: 10}}>
              {!profile ? (
                <View>
                  <UserCardMobile esiaRegInfo={esiaRegInfo} userType={'parent'} />
                </View>
              ) : null}
              {/* {haveKids ? (
                <View>
                  <Text style={styles.kidsSectionTitle}>Дети заявителя:</Text>
                  {kids.map((k, kidIndex) => (
                    <View key={kidIndex} style={{marginTop: 10}}>
                      <UserCardMobile userType={'kid'} kidId={kidIndex} key={kidIndex + 1} />
                    </View>
                  ))}
                </View>
              ) : null} */}
              <Button
                id='esia_reg_card'
                type='secondary'
                text={isDesktopSize ? 'Оформить нефинансовую карту' : 'Оформить карту'}
                disabled={!parent?.checked}
                style={styles.btn}
                onPress={() => navigation.navigate(Screens.EsiaRegistrationCard)}
              />
            </View>
          </CustomScrollView>
        </View>
      </SafeAreaView>
    </Screen>
  );
};
